// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"603a8d2d","453":"45884f98","455":"fcb73ccc","500":"f05c6ab9","531":"65609f87","977":"e4ea2986"}[chunkId] + ".chunk.js";
};